import { FinalWebhookStatus, ProcessingState } from '../../enum';

export interface SearchOrderHistoryResponseDto {
  source: string;
  orderCacheId: number;
  orderId: number;
  merchantId: number;
  merchantName: string;
  merchantLink: string;
  posDeviceId: number;
  posDeviceName: string;
  posDeviceTypeId: number;
  posDeviceTypeName: string;
  processingState: ProcessingState;
  paymentStatus: FinalWebhookStatus,
  paymentResponse: any;
  isDataLoss: number;
  amount: number;
  orderLink: string;
  createdDate: Date;
  operatorId: number;
  operatorFirstName: string;
  operatorLastName: string;
  isSettled?: boolean;
  basketId?: string;
  basketIdCount?: number;
  orderPayments: CartPayment[];
  orderItems: CartItem[];
}

interface CartPayment {
  id: number;
  authorizedAmount: number;
  amount: number; // settled - refunded
  settledAmount: number;
  refundedAmount: number;
  message: string;
  isCard: boolean;
  isCash: boolean;
  isGiftCard: boolean;
  cardNumber?: string;
  surfboardSettlementTransaction: SettlementTransaction
}

interface SettlementTransaction {
  type: string;
  currency: string;
  settlementDate: string;
  settledAmount: number;
}

export interface CartItem {
  itemName: string;
  quantity: number;
  basePrice: number;
  discountAmount: number;
}

